'use client'

import Image from "next/image"
import { Splide, SplideSlide } from '@splidejs/react-splide';
import {StrapiImageProps} from "@/app/types/strapi.types";
import {LogoSliderProps} from "@/app/types/flexible-content.types";

export default function LogoSlider(props: {data: LogoSliderProps}) {
    return (
        <section className="py-12">
            <div className="container">
                {props.data.Logos ? (
                    <Splide
                        options={{
                            gap: 60,
                            focus: "center",
                            pagination: false,
                            arrows: false,
                            autoWidth: true,
                            autoplay: true,
                            type: "loop",
                            interval: 1500,
                            pauseOnHover: false,
                        }}
                    >
                        {props.data.Logos.data.map((image: StrapiImageProps, index: number) => (
                            <SplideSlide key={index}>
                                <Image quality={85} src={image.attributes.url} width={image.attributes.width} height={image.attributes.height} alt={image.attributes.alternativeText} />
                            </SplideSlide>
                        ))}
                    </Splide>
                ) : null}
            </div>
        </section>
    )
}
